var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatMap2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 112,
    viewBox: "0 0 96 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1693_26300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2309 48.1433C13.2239 57.7817 19.3471 65.9686 22.5346 68.8572C19.8471 80.9461 25.1062 90.6198 28.0717 93.9455C39.4427 101.694 37.1602 105.511 57.1681 103.912C74.7956 97.9213 80.5974 59.6279 81.7163 33.2366C75.7498 19.132 66.6523 14.1595 60.4376 11.6769C45.3596 5.53535 37.1606 8.71632 33.4362 11.5437C22.5623 17.2777 18.4709 26.7757 18.8577 32.7411C15.138 36.6614 14.2233 44.6427 14.2309 48.1433Z",
    fill: "#499FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8053 48.8459C15.8991 57.864 21.7802 65.5627 24.834 68.2848C22.3398 79.5877 27.4057 88.6736 30.2504 91.8037C37.3854 101.291 50.2877 104.545 55.8469 104.986C73.7925 108.493 84.9819 61.8891 81.0383 35.2646C79.6109 21.0887 67.3809 12.8272 61.4443 10.4684C47.0404 4.6349 36.3719 8.42918 32.8382 11.0555C22.5067 16.3634 20.7275 28.8647 21.1293 34.4518C17.6061 38.1013 16.7786 45.5685 16.8053 48.8459Z",
    fill: "#30CB87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5524 77.105C31.7436 79.8342 33.8084 83.2351 34.6919 84.5945C35.1076 86.8367 38.2483 90.0738 39.7667 91.4121C49.133 97.3723 56.6713 97.9017 60.1346 97.5306C69.6405 98.523 79.5835 72.461 71.9244 58.2838L72.741 51.0325L72.0516 44.2619C77.21 29.0427 66.8813 20.6774 62.0553 17.2163C47.8171 9.86968 39.8219 13.0058 34.8881 16.9933C23.5453 27.1364 24.8916 36.9055 27.2424 42.4461L28.4861 47.3718L28.973 57.2575L30.5459 67.3636L30.5524 77.105Z",
    fill: "#FFC909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5365 52.2382C34.8996 57.5123 39.0086 62.3665 41.0178 64.1343C35.9985 68.7228 36.4953 76.2528 37.3711 79.4442C38.8666 89.1228 51.1759 92.4466 57.1437 92.8986C68.6082 92.7863 72.204 79.9943 72.5689 73.6123L71.3371 69.9612L70.62 66.3588L68.7778 59.4549L67.8174 57.3671L66.5381 51.0557C69.1109 46.1555 66.3904 38.9808 64.7086 36.0059C65.3017 28.3942 61.8392 23.7131 60.0338 22.324C52.2306 14.4762 43.1447 18.4147 39.5772 21.365C32.2506 26.8693 32.5201 34.8743 33.5707 38.1887C31.6883 45.5825 33.4302 50.6358 34.5365 52.2382Z",
    fill: "#FF2F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1693_26300",
    x: 10.1201,
    y: 3.39551,
    width: 75.709,
    height: 105.777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1693_26300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap2);
export default __webpack_public_path__ + "static/media/heatMap2.113d603bee3a0b2c34ae178be2033df5.svg";
export { ForwardRef as ReactComponent };